module.exports = __webpack_public_path__ + "8f96e20ed769ed8657bc2b8eb9aae57e.png";